import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DeprecatedCalloutService } from './callout.service';

/**
 * @deprecated Use riv-callout-outlet instead.
 * @see https://rivethealth.github.io/design-system/?path=/story/lib-modal-callout--example
 */
@Component({
  selector: 'deprecated-callout-outlet',
  templateUrl: './callout-outlet.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeprecatedCalloutOutletComponent {
  constructor(readonly calloutService: DeprecatedCalloutService) {}
}
